import { jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from "react";
import PropTypes from "prop-types";
import { TokenInputEditWrapper, TokenInputEditImpl } from "./token-input-edit.styles.es.js";
const propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string
};
const defaultProps = {
  placeholder: void 0,
  value: ""
};
const TokenInputEdit = forwardRef(
  ({ onChange, placeholder, value, ...restProps }, ref) => {
    const handleChange = useCallback(
      (event) => {
        onChange(event.currentTarget.value);
      },
      [onChange]
    );
    return /* @__PURE__ */ jsx(TokenInputEditWrapper, { "data-value": value || placeholder, children: /* @__PURE__ */ jsx(
      TokenInputEditImpl,
      {
        ref,
        onChange: handleChange,
        placeholder,
        value,
        ...restProps
      }
    ) });
  }
);
TokenInputEdit.propTypes = propTypes;
TokenInputEdit.defaultProps = defaultProps;
export {
  TokenInputEdit
};
